<template>
    <section>
        <div class="alert alert-primary d-flex justify-content-between" v-if="ids_retur.length > 0">
            <p class="m-0 font-sm">{{ ids_retur.length }} Retur Penjualan selected</p>
            <button 
                class="btn btn-sm btn-primary"
                @click="_setReturGroup"
            >
                Process
            </button>
        </div>
        <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
        />
        <Nodata v-if="!loading && retur_penjualan_ungroups.length == 0" />

        <div class="box" v-if="!loading && retur_penjualan_ungroups.length > 0">
            <div class="card">
                <div class="table-responsive">
                    <table
                        class="
                            table table-vcenter table-hover
                            card-table
                            table-striped
                        "
                    >
                        <thead>
                            <tr class="text-muted">
                                <th>
                                    <label
                                        class="form-check"
                                        style="position: absolute; top: 4px; left: 13px;"
                                    >
                                        <input
                                            type="checkbox"
                                            :checked="retur_penjualan_ungroups.length == ids_retur.length"
                                            @click="_checkUncheck"
                                            class="form-check-input"
                                        />
                                        <span class="form-check-label"></span>
                                    </label>
                                </th>
                                <th>Comp</th>
                                <th>No</th>
                                <th>Toko</th>
                                <th>Tim & Gudang</th>
                                <th>Tgl. Input</th>
                                <th>Kat. Retur</th>
                                <th>Grand Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(retur_ungroup, index) in retur_penjualan_ungroups" :key="index">
                                <td  class="text-right pos-relative">
                                    <label
                                        class="form-check"
                                        style="
                                            position: absolute;
                                            top: 45%;
                                            transform: translate(0, -49%);
                                            left: 13px;
                                        "
                                    >
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="retur_ungroup.id"
                                            v-model="ids_retur"
                                        />
                                        <span class="form-check-label"></span>
                                    </label>
                                </td>
                                <td>
                                    <span class="badge bg-blue-lt mr-2">
                                    {{ retur_ungroup.kode_perusahaan }}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        class="link-primary cursor-pointer"
                                    >
                                        {{ retur_ungroup.id }}
                                    </span>
                                </td>
                                <td :class="{ 'text-primary': retur_ungroup.id_mitra != 0 }">
                                    {{ retur_ungroup.nama_toko }} <br />
                                    {{ retur_ungroup.no_acc }}
                                </td>

                                <td>
                                    {{ retur_ungroup.nama_tim }} ({{ retur_ungroup.tipe_tim }})
                                    <br />
                                    {{ retur_ungroup.nama_gudang }}
                                    <br />
                                    <span v-if="retur_ungroup.verified_by" class="bg-info badge w-100">{{ retur_ungroup.nama_koordinator }} -
                                    {{ retur_ungroup.verified_at }}</span
                                    >
                                </td>

                                <td>{{ dateFormat(retur_ungroup.sales_retur_date) }}</td>

                                <td>{{ retur_ungroup.tipe_barang }}</td>

                                <td>
                                    <div>
                                        Rp {{ ribuan(Math.round(retur_ungroup.grand_total)) }}
                                    </div>
                                </td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <b-pagination
                v-if="retur_penjualan_ungroups.length > 0 && !loading"
                align="center"
                class="mt-5"
                :total-rows="paginate.totalRows"
                v-model="paginate.currentPage"
                :per-page="paginate.perPage"
                @change="_pageChange"
            />
        </div>

        <FormFilter
            :config.sync="filter.config"
            :initData="filter.data"
            :dismiss.sync="filter.dismiss"
            :isSubmit.sync="filter.isSubmit"
            @submit="filter.action"
        />
    </section>
</template>
<script>
import FormFilter from "./modals/filter.vue";
import { mapState, mapActions } from "vuex";
import helper from "@/assets/js/helper.js";

export default {
    name: "ReturPenjualanUngroup",
    components: {
        FormFilter,
    },
    data(){
        return {
            loading: false,
            ids_retur: [],
            
            filter: {
                config: { view: false, title: null },
                data: null,
                isSubmit: false,
                action: () => {},
            },
            dataFilter: {
                id_perusahaan: "",
                id_salesman: "all",
                start_date: "2020-01-03", //this.dateTime('ymd'),
                end_date: this.dateTime("ymd"),
                keyword: "",
                depo: [],
                id_mitra: "exclude",
            },
            paginate: {
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                fromPage: 0,
            },
        }
    },
    mixins: [helper],
    computed: {
        ...mapState("retur_penjualan_group", {
            retur_penjualan_ungroups: (state) => state.datas.ungroup,
        }),
    },
    methods: {
        ...mapActions("retur_penjualan_group", ["getReturPenjualanUngroup","setReturGroup"]),

        async _get(){
            this.loading = true;
            let formData = {
                id_perusahaan: this.dataFilter.id_perusahaan,
                id_salesman: this.dataFilter.id_salesman,
                per_page: this.paginate.perPage,
                page: this.paginate.currentPage,
                start_date: this.dataFilter.start_date,
                end_date: this.dataFilter.end_date,
                depo: this.dataFilter.depo,
                keyword: this.dataFilter.keyword,
                id_mitra: this.dataFilter.id_mitra,
                jenis_retur: this.dataFilter.jenis_retur,
            };
            try{
                const res = await this.getReturPenjualanUngroup(formData)
                this.paginate.totalRows = res.total;
                this.loading = false;
            }catch(err){
                this.loading = false;
                this.onError();
            }
        },
        _setReturGroup(){
            try {
                this.$swal.fire({
                    title: 'Peringatan',
                    text: "Yakin ingin group retur penjualan?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Group it!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.loading = true
                        try{
                            const res = await this.setReturGroup({'ids_retur': this.ids_retur})
                            this.toast(res.message);
                        }catch(err){
                            this.onError(err);
                        }
                        this._get()
                        this.loading = false;
                    }
                })
            } catch (error) {
                this.onError(error);
            }
        },
        _filter() {
            this.filter.config = { view: true, title: "Filter" };
            this.filter.action = (formData) => {
                for (const key in formData) {
                    this.dataFilter[key] = formData[key];
                }
                if (this.dataFilter.id_salesman === "") {
                    this.dataFilter.id_salesman = "all";
                }
                this._get()
            };
        },
        _checkUncheck(){
            if (this.ids_retur.length != this.retur_penjualan_ungroups.length) {
                this.ids_retur = [];
                for (let i = 0; i < this.retur_penjualan_ungroups.length; i++) {
                    let item = this.retur_penjualan_ungroups[i];
                    this.ids_retur.push(item.id);
                }
            }else{
                this.ids_retur = [];
            }
            console.log(this.ids_retur)
        },
        _search(keyword) {
            this.dataFilter.keyword = keyword;
            this._get();
        },
        _perPageChange(perPage){
            this.paginate.perPage = perPage;
            this._get()
        },
        _pageChange(page) {
            this.paginate.currentPage = page;
            this._get();
        },
    },
    mounted() {
        this._get();
    },
}
</script>
